<template>
  <div style="width: 100%; display: flex">
    <el-button @click="dialogObject=true">+ Импорт из excel</el-button>
    <el-dialog v-loading="loader" title="Прикрепить excel файл" :visible.sync="dialogObject">
      <el-upload
        style="margin-bottom: 20px"
        v-if="uploadValue === null"
        list-type="picture"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        :http-request="onUpload"
        class="upload-demo"
        action="/"
        :show-file-list="false"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Перетащите файл сюда или <br/><em>нажмите, чтобы загрузить</em></div>
      </el-upload>
      <el-progress v-else :percentage="uploadValue"></el-progress>

      <a href="/static/workorders.xlsx">
        <el-button type="primary" @click="dialogObject = false">Скачать шаблон</el-button>
      </a>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {apiUrl} from "../../../plugins/firebase";

export default {
  name: 'ImportFromExcel',
  data() {
    return {
      dialogObject: false,
      uploadValue: null,
      loader: false,
      step: 0,
    };
  },
  methods: {
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject('Error: ', error);
        };
      });
    },
    async onUpload(e) {
      const imageData = await this.getBase64(e.file);

      this.loader = true;

      const proxy = firebase.functions().httpsCallable('onParseWorkOrders');
      proxy(
        {
          uid: authFirestore.currentUser.uid,
          workOrders: imageData,
          projectId: this.$store.state.project.id,
        },
      ).then((response) => {
        this.$notify({
          title: 'Успешно!',
          message: 'Объекты загружены',
          type: 'success',
        });
        this.dialogObject = false;
        this.$emit('update')
      }).catch((error) => {
        this.$notify({
          title: 'Произошла ошибка',
          message: 'Файл загрузки не соответствует шаблону',
          type: 'error',
        });
      }).finally(() => {
        this.loader = false;
      });
    },
    save() {
      this.$emit('update');
      this.close();
    },
    close() {
      this.dialogObject = false;
    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  margin: 0 auto;
  width: calc(100% - 20px);

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
  }
}

.el-upload--picture {
  display: flex;
  justify-content: center;
}

.el-loading-mask {
  position: fixed !important;
  background-color: rgba(255,255,255,.4) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/ImportFromExcel.vue